import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Modal = ({classes, showModal, setShowModal, content}) => {
    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        if (showModal && !document.body.classList.contains('modal-active')) {
            setTimeout(() => {
                document.body.classList.add('modal-active');
            }, 50);
        }
        if (!showModal && document.body.classList.contains('modal-active')) {
            document.body.classList.remove('modal-active');
        }
        return () => {
            if (document.body.classList.contains('modal-active')) {
                document.body.classList.remove('modal-active');
            }
            if (showModal) {
                setShowModal(!showModal);
            }
        };
    }, [showModal]);

    useEffect(() => {
        if (showModal) {
            setShowModal(null);
        }
    }, [pathname]);

    if (!showModal) {
        return;
    }

    return (
        <section className={`modal ${classes}`}>
            <div className="overlay">
                <span className="loading-decor-l" />
                <span className="loading-decor-r" />
            </div>
            <div className="content relative">
                <div className="container">
                    <header className="flex items-center justify-end pb-12 pt-[50.69px]">
                        <button
                            type="button"
                            onClick={() => setShowModal(false)}
                            className="btn btn-header btn-utility"
                            aria-label="Close"
                        >
                            <span><span className="modal-icon modal-icon-close" aria-hidden="true" /></span>
                        </button>
                    </header>
                </div>
                {content}
            </div>
        </section>
    );
};

export default Modal;
